import React from 'react'
import clientData from 'utils/client-data'
import glamorous from 'glamorous'
import { get } from 'lodash'
import { HeadingText } from '@paypalcorp/pp-react'
import { phone6PlusPortraitMaxAndSmaller } from '../../../lib/styles/media-queries'

// content
import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/error')

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start', // 'center',
  marginTop: '38px',
})

const HeadingContainer = glamorous.div({
  textAlign: 'center',
})

const ButtonContainer = glamorous.div({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%,0%)',
  bottom: '-70%',
  [phone6PlusPortraitMaxAndSmaller]: {
    width: '100%',
    bottom: '-50%',
  },
})

const GoToSellerProfileButton = glamorous.button({
  margin: '20px auto',
  width: '300px',
  [phone6PlusPortraitMaxAndSmaller]: {
    width: '100%',
  },
})

const ErrorAlreadyHasProfile = props => {
  const onGoToSellerProfileClick = () => {
    const businessHandle = get(clientData, 'sellerProfileDetails.id')
    props.history.push(`/seller/${businessHandle}/dashboard`)
  }

  return (
    <Container>
      <HeadingContainer>
        <HeadingText size="md" role="heading" aria-level="1">
          {l10n('error.header.alreadyHasSellerProfile')}
        </HeadingText>
      </HeadingContainer>

      <ButtonContainer>
        <GoToSellerProfileButton
          className="vx_btn"
          label="GoToSellerProfile"
          onClick={onGoToSellerProfileClick}
        >
          {l10n('error.button.alreadyHasSellerProfile')}
        </GoToSellerProfileButton>
      </ButtonContainer>
    </Container>
  )
}

export default ErrorAlreadyHasProfile
